import React from 'react';
import { NikoInsuranceManagementEditTemplate } from 'themes/application/niko-insurance-management/pages';
import { observer } from 'mobx-react';
import { NikoInsuranceManagementEditViewStore } from 'application/niko-insurance-management/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new NikoInsuranceManagementEditViewStore(rootStore), 'nikoInsuranceManagementEditViewStore')
@observer
class NikoInsuranceManagementEdit extends React.Component {
    render() {
        return <NikoInsuranceManagementEditTemplate {...this.props} />
    }
}

export default NikoInsuranceManagementEdit;
